import { render, staticRenderFns } from "./UpdateReturnBill.vue?vue&type=template&id=046c1b40&scoped=true"
import script from "./UpdateReturnBill.vue?vue&type=script&lang=js"
export * from "./UpdateReturnBill.vue?vue&type=script&lang=js"
import style0 from "./UpdateReturnBill.vue?vue&type=style&index=0&id=046c1b40&prod&scoped=true&lang=css"
import style1 from "./UpdateReturnBill.vue?vue&type=style&index=1&id=046c1b40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046c1b40",
  null
  
)

export default component.exports